import { AuthStore } from './auth/auth.store';
import { ResourceStore } from './resources/resource.store';
import { ActivityStore } from './resources/activity.store';
import { BookstoreStore } from './bookstore/bookstore.store';
import { CurriculumStore } from './resources/curriculum.store';
import { DictionaryStore} from './dictionary.store'
import { GrammarInUseStore } from './resources/grammarInUse';
import { PlacementTest } from './testingCenter/placementTest.store';
import { EnrollmentStore } from './enrollment/enrollment.store';
import { ClassroomStore } from './enrollment/classroom.store';
import { ConfigStore } from './config.store';
import { RegisterTesting } from './enrollment/registerTesting.store';
import { AppCenter } from './appCenter.store';
import { TrainingStore } from './training/training.store';

export const APP_STORES=[
    AuthStore,
    ResourceStore,
    ActivityStore,
    BookstoreStore,
    CurriculumStore,
    DictionaryStore,
    GrammarInUseStore,
    PlacementTest,
    EnrollmentStore,
    ClassroomStore,
    ConfigStore,
    RegisterTesting,
    AppCenter,
    TrainingStore,
]